import { apiGet } from './client';
import type { Paginated } from '@/types/platform';

/**
 * A group synced or pushed from an identity provider.
 *
 * `member_count` is computed live by the backend from active principals'
 * group memberships (never the denormalized stored counter).
 */
export interface PrincipalGroup {
  id: string;
  name: string;
  identity_provider_id: string;
  identity_provider_name: string;
  external_id: string;
  member_count: number;
  created_at: string;
  updated_at: string | null;
}

export interface ListGroupsParams {
  page?: number;
  per_page?: number;
  /** Case-insensitive substring filter on group name. */
  search?: string;
}

/** Fetch a paginated page of IdP-synced groups for the current organization. */
export function getGroups(
  params: ListGroupsParams = {},
): Promise<Paginated<PrincipalGroup>> {
  return apiGet<Paginated<PrincipalGroup>>(
    '/groups',
    params as Record<string, string | number | undefined>,
  );
}
